import {
  type DocumentNode,
  type MutationHookOptions,
  type OperationVariables,
  useMutation,
} from "@apollo/client";
import {
  CloseContentPollMutation,
  CreateContentPollMutation,
  CreatePollMutation,
  DeleteContentPollMutation,
  DeletePollsMutation,
  OpenContentPollMutation,
  UpdateContentPollMutation,
  UpdatePollMutation,
} from "../graphql/mutations";
import type {
  CloseContentPollMutationType,
  CloseContentPollMutationVariablesType,
  CreateContentPollMutationType,
  CreateContentPollMutationVariablesType,
  CreatePollMutationType,
  CreatePollMutationVariablesType,
  DeleteContentPollMutationType,
  DeleteContentPollMutationVariablesType,
  DeletePollsMutationType,
  DeletePollsMutationVariablesType,
  OpenContentPollMutationType,
  OpenContentPollMutationVariablesType,
  UpdateContentPollMutationType,
  UpdateContentPollMutationVariablesType,
  UpdatePollMutationType,
  UpdatePollMutationVariablesType,
} from "@/types/graphql/partner.generated";

// Список перечитывается после каждой мутации: состав, статусы и «где
// используется» меняются, а кеш по id не добавит новый элемент в список.
// Перечитываются только смонтированные запросы с этими именами.
const REFETCH = { refetchQueries: ["PollsList", "ContentPolls", "Poll"] };

const useRefetchingMutation = <TData, TVariables extends OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>
) => useMutation<TData, TVariables>(mutation, { ...REFETCH, ...options });

export const useCreatePollMutation = (
  options?: MutationHookOptions<
    CreatePollMutationType,
    CreatePollMutationVariablesType
  >
) => useRefetchingMutation(CreatePollMutation, options);

export const useUpdatePollMutation = (
  options?: MutationHookOptions<
    UpdatePollMutationType,
    UpdatePollMutationVariablesType
  >
) => useRefetchingMutation(UpdatePollMutation, options);

export const useDeletePollsMutation = (
  options?: MutationHookOptions<
    DeletePollsMutationType,
    DeletePollsMutationVariablesType
  >
) => useRefetchingMutation(DeletePollsMutation, options);

export const useCreateContentPollMutation = (
  options?: MutationHookOptions<
    CreateContentPollMutationType,
    CreateContentPollMutationVariablesType
  >
) => useRefetchingMutation(CreateContentPollMutation, options);

export const useUpdateContentPollMutation = (
  options?: MutationHookOptions<
    UpdateContentPollMutationType,
    UpdateContentPollMutationVariablesType
  >
) => useRefetchingMutation(UpdateContentPollMutation, options);

export const useDeleteContentPollMutation = (
  options?: MutationHookOptions<
    DeleteContentPollMutationType,
    DeleteContentPollMutationVariablesType
  >
) => useRefetchingMutation(DeleteContentPollMutation, options);

export const useOpenContentPollMutation = (
  options?: MutationHookOptions<
    OpenContentPollMutationType,
    OpenContentPollMutationVariablesType
  >
) => useRefetchingMutation(OpenContentPollMutation, options);

export const useCloseContentPollMutation = (
  options?: MutationHookOptions<
    CloseContentPollMutationType,
    CloseContentPollMutationVariablesType
  >
) => useRefetchingMutation(CloseContentPollMutation, options);
